import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  Avatar,
} from "@material-ui/core";
import {
  createGroupConversationAPI,
  getMyFollowersForChatAPI,
} from "../../../../api/messageApi";
import { useMessagesStyles } from "./style";
import { getFileByIdAPI } from "../../../../api/userApi";
import defaultAvatars from "../../../../assets/defaultAvatars.svg";

interface user {
  _id: string;
  firstName: string;
  lastName: string;
  username: string;
  profileImg: string;

  avatar?: string; // або avatarUrl / image, як у тебе в API
}
interface GroupChatModalProps {
  open: boolean;
  onClose: () => void;
  onCreate: (data: {
    groupName: string;
    participantIds: string[];
  }) => Promise<void>;
}
export const GroupChatModal: React.FC<GroupChatModalProps> = ({
  open,
  onClose,
  onCreate,
}) => {
  const classes = useMessagesStyles();
  const [groupName, setGroupName] = useState("");
  const [selectedUserIds, setSelectedUserIds] = useState<string[]>([]);
  const [users, setUsers] = useState<user[]>([]);
  const [loading, setLoading] = useState(true);
  const [mediaUrls, setMediaUrls] = useState<{ [key: string]: string }>({});
  const [searchQuery, setSearchQuery] = useState("");
  const [allUsers, setAllUsers] = useState<user[]>([]); // <- усі юзери

  const fetchMediaUrl = async (mediaUrl: string) => {
    if (!mediaUrl) return;
    // Якщо це Google URL (lh3.googleusercontent.com), використовуємо його напряму
    if (mediaUrl.includes("lh3.googleusercontent.com")) {
      setMediaUrls(prev => ({ ...prev, [mediaUrl]: mediaUrl }));
      return;
    }
    // Якщо це пряме посилання (https:// або http://), використовуємо його напряму
    if (mediaUrl.startsWith("https://") || mediaUrl.startsWith("http://")) {
      setMediaUrls(prev => ({ ...prev, [mediaUrl]: mediaUrl }));
      return;
    }
    const fileId = mediaUrl.split("/api/files/")[1];
    if (!fileId) return;

    try {
      const blobUrl = await getFileByIdAPI(fileId);
      setMediaUrls(prev => ({ ...prev, [mediaUrl]: blobUrl }));
    } catch (err) {
      console.error(`Error fetching avatar for ${mediaUrl}:`, err);
    }
  };
  useEffect(() => {
    users.forEach(user => {
      if (user.profileImg && !mediaUrls[user.profileImg]) {
        fetchMediaUrl(user.profileImg);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  // useEffect(() => {
  //     if (open) {
  //         getMyFollowersForChatAPI()
  //             .then((res) => {
  //                 if (res.success) {
  //                     setUsers(res.items.filter((u: any) => u !== null));
  //                 }
  //             })
  //             .catch((err) => console.error("Failed to fetch followers", err))
  //             .finally(() => setLoading(false));
  //     }
  // }, [open]);
  useEffect(() => {
    if (open) {
      setLoading(true);
      getMyFollowersForChatAPI()
        .then(res => {
          if (res.success) {
            const filtered = res.items.filter((u: any) => u !== null);
            setAllUsers(filtered); // <- зберігаємо оригінал
            setUsers(filtered); // <- спочатку показуємо всіх
          }
        })
        .catch(err => console.error("Failed to fetch followers", err))
        .finally(() => setLoading(false));
    }
  }, [open]);

  useEffect(() => {
    if (!searchQuery.trim()) {
      setUsers(allUsers);
    } else {
      const lower = searchQuery.toLowerCase();
      const filtered = allUsers.filter(user => {
        const fullName = `${user.firstName} ${user.lastName}`.toLowerCase();
        return (
          fullName.includes(lower) ||
          user.username.toLowerCase().includes(lower)
        );
      });
      setUsers(filtered);
    }
  }, [searchQuery, allUsers]);

  const toggleUser = (id: string) => {
    setSelectedUserIds(prev =>
      prev.includes(id) ? prev.filter(uid => uid !== id) : [...prev, id]
    );
  };

  const handleCreate = async () => {
    try {
      const res = await createGroupConversationAPI({
        groupName,
        participantIds: selectedUserIds,
      } as any);
      if (res.data.success) {
        onCreate(res.data);
        setGroupName("");
        setSelectedUserIds([]);
        onClose();
      } else {
        alert(res.data.message || "Failed to create group");
      }
    } catch (error) {
      console.error("Create group error", error);
      alert("Something went wrong");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      style={{ height: 850 }}
    >
      <DialogTitle className={classes.dialogTitleGroup}>
        Create Group Chat
      </DialogTitle>
      {/* <Typography
        className={classes.dialogMinTitleGroup}
        variant="subtitle1"
        gutterBottom
      >
        Name Group:
      </Typography> */}
      <DialogContent className={classes.dialogContentGroup}>
        {/* <TextField
          fullWidth
          value={groupName}
          onChange={e => setGroupName(e.target.value)}
          className={classes.textFieldGroup}
        /> */}

        <Typography style={{ marginTop: "15px" }} gutterBottom>
          Select Participants:
        </Typography>
        <TextField
          placeholder="Search followers..."
          variant="outlined"
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          fullWidth
          style={{ marginBottom: 16 }}
          className={classes.textFieldSearchGroup}
          InputProps={{
            classes: {
              notchedOutline: classes.noBorder,
            },
          }}
        />

        <Box className={classes.groupChatuserBox}>
          {loading ? (
            <Typography>Loading...</Typography>
          ) : users.length === 0 ? (
            <Typography>No followers found</Typography>
          ) : (
            users.map(user => {
              const isSelected = selectedUserIds.includes(user._id);
              return (
                <Box
                  key={user._id}
                  className={`${classes.boxUserGroup} ${
                    isSelected ? classes.selectedUser : ""
                  }`}
                  onClick={() => toggleUser(user._id)}
                >
                  <input
                    type="checkbox"
                    value={user._id}
                    checked={isSelected}
                    onChange={() => toggleUser(user._id)}
                    style={{ display: "none" }}
                  />
                  <Box display="flex" alignItems="center">
                    <Avatar
                      src={mediaUrls[user.profileImg] || defaultAvatars}
                    />

                    <Box className={classes.nameUserNameGroup}>
                      <Typography
                        style={{
                          marginLeft: 12,
                          fontSize: 14,
                          fontWeight: 700,
                          color: "#FFFFFF",
                        }}
                      >
                        {user.firstName} {user.lastName}
                      </Typography>
                      <Typography
                        style={{
                          marginLeft: 12,
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        @{user.username}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              );
            })
          )}
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialogActionsGroupFooter}>
        <Button
          className={classes.dialogActionsGroupFooterCancel}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          className={classes.dialogActionsGroupFooterCreate}
          onClick={handleCreate}
          color="primary"
          variant="contained"
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};
